import queryString from "query-string";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import actions from "./ducks/actions";
import operations from "./ducks/operations";

const LoginContainer = (props) => {
    useEffect(() => {
        const params = queryString.parse(window.location.search);
        const code = params.code;
        if (code) {
            props.login(code);
        }
    }, []);
    const params = queryString.parse(window.location.search);
    const code = params.code;
    return <div>{!code && "Invalid Login"}</div>;
};

const mapStateToProps = (state) => {
    return {
        valid: state.authReducer.validFormValues,
        snackbarOpen: state.authReducer.snackbarOpen,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleChangeAndValidate: (event) => {
            dispatch(operations.handleChangeAndValidate(event.target.id, event.target.value));
        },
        hideSnackbar: () => {
            dispatch(operations.hideSnackbar());
        },
        login: async (code) => {
            const { history } = ownProps;
            const mainPage = await dispatch(operations.login(code));
            history.push(mainPage);
            dispatch(actions.toggleLoggedIn());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginContainer));
